module.exports = __webpack_public_path__ + "img/hxlogo_text.b992250d.png";